import {CacheStore} from '../stores/cache.store';
import {inject, Injectable} from '@angular/core';
import {CacheItem} from '../models/cache-item.model';
import {CacheNameEnum} from '../enums/cache/cache-name.enum';
import {QueryService} from '../modules/akita-mimic/services/query.service';
import {CacheState} from '../modules/akita-mimic/models/store-states/cache-state.model';

@Injectable({ providedIn: 'root' })
export class CacheQuery extends QueryService<CacheState> {
    public constructor() {
        const store = inject(CacheStore);
        super(store);
    }

    public getCacheItemById(id: string): CacheItem | undefined {
        return this.getValue()
            .items
            .filter(item => item.id === id)
            .shift();
    }

    public getCacheItems(): Array<CacheItem> {
        return this.getValue().items;
    }

    public getMaxAgeInSecondsByCacheName(name: CacheNameEnum): number | undefined {
        const maxAgesInSeconds = this.getValue().maxAgesInSeconds;

        if (maxAgesInSeconds) {
            return maxAgesInSeconds[name];
        }

        return undefined;
    }
}
